var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dc-card-wrapper" }, [
    _c("h3", { staticClass: "date-header row" }, [
      _vm._v(_vm._s(_vm.feedDate))
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "dc-card",
        class: {
          "no-image": !_vm.dailyChallenge.image,
          "is-complete": _vm.dailyChallenge.complete
        }
      },
      [
        _c(
          "router-link",
          {
            staticClass: "dc-card-content",
            attrs: {
              to: {
                name: "daily_problems_problem",
                params: { slug: _vm.dailyChallenge.slug }
              }
            }
          },
          [
            _vm.dailyChallenge.complete
              ? [
                  _c("div", { staticClass: "info" }, [
                    _c("div", { staticClass: "b-title-meta track" }, [
                      _vm._v(_vm._s(_vm.dailyChallenge.track))
                    ]),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "related-course-link",
                        attrs: { href: _vm.dailyChallenge.related_course_link }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.dailyChallenge.related_course_name) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("h4", { staticClass: "b-title-section" }, [
                      _vm._v(_vm._s(_vm.dailyChallenge.title))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "complete-pill" }, [
                      _vm._v("COMPLETE")
                    ])
                  ])
                ]
              : [
                  _vm.dailyChallenge.image
                    ? _c(
                        "div",
                        { staticClass: "img" },
                        [
                          _c("BriocheImageTag", {
                            attrs: {
                              src: _vm.dailyChallenge.image,
                              width: 376,
                              alt: _vm.dailyChallenge.title
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "info" }, [
                    _c("div", { staticClass: "text" }, [
                      _c("div", { staticClass: "b-title-meta track" }, [
                        _vm._v(_vm._s(_vm.dailyChallenge.track))
                      ]),
                      _vm._v(" "),
                      _c("h4", { staticClass: "b-title-section" }, [
                        _vm._v(_vm._s(_vm.dailyChallenge.title))
                      ]),
                      _vm._v(" "),
                      _c("p", [_vm._v(_vm._s(_vm.dailyChallenge.preview_copy))])
                    ]),
                    _vm._v(" "),
                    _vm.isSeries
                      ? _c("div", { staticClass: "footer" }, [
                          _c("span", { staticClass: "series" }, [
                            _c("span", [_vm._v("Series")]),
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.dailyChallenge.series.position) +
                                " of " +
                                _vm._s(_vm.dailyChallenge.series.total) +
                                "\n            "
                            )
                          ])
                        ])
                      : _vm._e()
                  ])
                ]
          ],
          2
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }